import React, { createContext, useContext } from 'react';
import { THEME } from './fm-radio-button/fm-radio-button';

export interface FMRadioButtonGroupContextValues {
    name: string;
    checked?: string | number;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    disabled?: boolean;
    required?: boolean;
    error?: boolean;
    theme?: THEME;
}
export const FMRadioButtonGroupContextWrapper = createContext<FMRadioButtonGroupContextValues | null>(
    null
);

export function useFMRadioButtonGroupContext(): FMRadioButtonGroupContextValues | null {
    const context = useContext(FMRadioButtonGroupContextWrapper);
    if (!context) {
        return null;
    }
    return context;
}
